/* __next_internal_client_entry_do_not_use__ SDUIBackgroundIcon auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { getSlateSpacingPixelsString } from "@faire/retailer-shared/SlateMappings/getSlateSpacingPixels";
import { SDUIImageOrIconRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/ImageOrIcon/SDUIImageOrIconRenderer";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { Alignment } from "@faire/web-api--source/indigofair/data/Alignment";
import { Spacing } from "@faire/web-api--source/indigofair/data/Spacing";
import React from "react";
export var SDUIBackgroundIcon = function(param) {
    var backgroundIcon = param.backgroundIcon, responsiveBackgroundIcon = param.responsiveBackgroundIcon;
    var _responsiveBackgroundIcon_mobile_and_above;
    var mobileBackgroundIcon = (_responsiveBackgroundIcon_mobile_and_above = responsiveBackgroundIcon === null || responsiveBackgroundIcon === void 0 ? void 0 : responsiveBackgroundIcon.mobile_and_above) !== null && _responsiveBackgroundIcon_mobile_and_above !== void 0 ? _responsiveBackgroundIcon_mobile_and_above : backgroundIcon;
    var _responsiveBackgroundIcon_tablet_and_above;
    var tabletBackgroundIcon = (_responsiveBackgroundIcon_tablet_and_above = responsiveBackgroundIcon === null || responsiveBackgroundIcon === void 0 ? void 0 : responsiveBackgroundIcon.tablet_and_above) !== null && _responsiveBackgroundIcon_tablet_and_above !== void 0 ? _responsiveBackgroundIcon_tablet_and_above : mobileBackgroundIcon;
    var _responsiveBackgroundIcon_desktop_and_above;
    var desktopAndAboveBackgroundIcon = (_responsiveBackgroundIcon_desktop_and_above = responsiveBackgroundIcon === null || responsiveBackgroundIcon === void 0 ? void 0 : responsiveBackgroundIcon.desktop_and_above) !== null && _responsiveBackgroundIcon_desktop_and_above !== void 0 ? _responsiveBackgroundIcon_desktop_and_above : tabletBackgroundIcon;
    return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
        mobile: (mobileBackgroundIcon === null || mobileBackgroundIcon === void 0 ? void 0 : mobileBackgroundIcon.icon) ? /*#__PURE__*/ _jsx(SDUIImageOrIconRenderer, {
            dataTestId: "sdui-background-icon-mobile",
            imageOrIcon: mobileBackgroundIcon.icon,
            componentStyle: getInlineStylesForBackgroundIcon(mobileBackgroundIcon)
        }) : undefined,
        tablet: (tabletBackgroundIcon === null || tabletBackgroundIcon === void 0 ? void 0 : tabletBackgroundIcon.icon) ? /*#__PURE__*/ _jsx(SDUIImageOrIconRenderer, {
            dataTestId: "sdui-background-icon-tablet",
            imageOrIcon: tabletBackgroundIcon.icon,
            componentStyle: getInlineStylesForBackgroundIcon(tabletBackgroundIcon)
        }) : undefined,
        desktopAndAbove: (desktopAndAboveBackgroundIcon === null || desktopAndAboveBackgroundIcon === void 0 ? void 0 : desktopAndAboveBackgroundIcon.icon) ? /*#__PURE__*/ _jsx(SDUIImageOrIconRenderer, {
            dataTestId: "sdui-background-icon-desktop",
            imageOrIcon: desktopAndAboveBackgroundIcon.icon,
            componentStyle: getInlineStylesForBackgroundIcon(desktopAndAboveBackgroundIcon)
        }) : undefined,
        noJS: true
    });
};
/**
 * Assigns CSS styles for correct placement of the absolutely positioned background icon
 * based on server provided `position` values.
 */ var getInlineStylesForBackgroundIcon = function(backgroundIcon) {
    var inlineStyleVars = getInlineStyleVars(backgroundIcon);
    return {
        top: inlineStyleVars === null || inlineStyleVars === void 0 ? void 0 : inlineStyleVars.top,
        bottom: inlineStyleVars === null || inlineStyleVars === void 0 ? void 0 : inlineStyleVars.bottom,
        left: inlineStyleVars === null || inlineStyleVars === void 0 ? void 0 : inlineStyleVars.left,
        right: inlineStyleVars === null || inlineStyleVars === void 0 ? void 0 : inlineStyleVars.right,
        transform: inlineStyleVars === null || inlineStyleVars === void 0 ? void 0 : inlineStyleVars.transform,
        position: "absolute"
    };
};
var getInlineStyleVars = function(backgroundIcon) {
    if (!(backgroundIcon === null || backgroundIcon === void 0 ? void 0 : backgroundIcon.position)) {
        return undefined;
    }
    var topValue = getTopLeftStyleValue(backgroundIcon.position.vertical_alignment);
    var leftValue = getTopLeftStyleValue(backgroundIcon.position.horizontal_alignment);
    var rightValue = getBottomRightStyleValue(backgroundIcon.position.horizontal_alignment);
    var bottomValue = getBottomRightStyleValue(backgroundIcon.position.vertical_alignment);
    var transformValue = getTransformStyleVar(leftValue, backgroundIcon.position.horizontal_offset, topValue, backgroundIcon.position.vertical_offset);
    return {
        top: topValue,
        left: leftValue,
        right: rightValue,
        bottom: bottomValue,
        transform: transformValue
    };
};
var getTopLeftStyleValue = function(alignment) {
    switch(alignment){
        case Alignment.ALIGNMENT_START:
            return "0px";
        case Alignment.ALIGNMENT_CENTER:
            return "50%";
    }
    return undefined;
};
var getBottomRightStyleValue = function(alignment) {
    return alignment === Alignment.ALIGNMENT_END ? "0" : undefined;
};
/**
 * Negative values are used to center the position:absolute icon if ALIGNMENT_CENTER
 * but we also need to combine it with the offset to get the final transform value.
 * We use 0px instead of 0 because calc does not work with unitless values
 */ var getTransformStyleVar = function(initialTransformValueX, offsetTransformValueX, initialTransformValueY, offsetTransformValueY) {
    return "translate(calc(-".concat(initialTransformValueX !== null && initialTransformValueX !== void 0 ? initialTransformValueX : "0px", " + ").concat(getOffsetTransformValue(offsetTransformValueX), "), calc(-").concat(initialTransformValueY !== null && initialTransformValueY !== void 0 ? initialTransformValueY : "0px", " + ").concat(getOffsetTransformValue(offsetTransformValueY), "))");
};
/**
 * Calculates the px offset of the icon in pixels based on the current viewport size.
 * Falls back to no offset if not defined.
 */ var getOffsetTransformValue = function(offset) {
    var _offset_positive, _ref;
    return "".concat((offset === null || offset === void 0 ? void 0 : offset.positive) ? "" : "-").concat(getSlateSpacingPixelsString((_ref = (_offset_positive = offset === null || offset === void 0 ? void 0 : offset.positive) !== null && _offset_positive !== void 0 ? _offset_positive : offset === null || offset === void 0 ? void 0 : offset.negative) !== null && _ref !== void 0 ? _ref : Spacing.SPACING_NONE));
};
